import Link from "next/link";
import { useRouter } from "next/router";

import { Card, Tag } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";

import { CancelSubscriptionButton } from "../CancelSubscriptionButton";

import { intl } from "./SubscriptionStatusActive.Intl";

export const SubscriptionStatusActive = () => {
  const router = useRouter();
  return (
    <section>
      <Card className="flex flex-col gap-3 " id="abonnement-status-card">
        <div className="flex justify-between">
          <h2 className="text-xl">
            <strong>{intl.SUBSCRIPTION_STATUS}</strong>
          </h2>
          <Tag small information className="text-xs text-white ">
            {intl.STATUS}
          </Tag>
        </div>

        <div className="text-sm">
          <p>
            <strong>{intl.YOUR_SUBSCRIPTION_IS_ACTIVE}</strong>
          </p>
          <p>
            {intl.IF_YOU_WANT_TO_PAUSE_YOUR_SUBSCRIPTION_FOR_A_WEEK_DO_IT_VIA}{" "}
            <Link
              href={BRAND_PATHS.DELIVERY_CALENDAR_UPCOMING_LINK}
              passHref
              className="underline"
            >
              <strong>{intl.YOUR_DELIVERY_CALENDAR}</strong>
            </Link>
          </p>
        </div>

        <div className="justify-start">
          <CancelSubscriptionButton
            id="cancel-subscription-button"
            onConfirm={() => router.push(BRAND_PATHS.CHOOSE_OPTION_TO_PAUSE)}
            linkToPauseSubscriptionForPeriodPage={
              BRAND_PATHS.PAUSE_SUBSCRIPTION_FOR_PERIOD_PAGE_PATH
            }
          />
        </div>
        <div className="mt-2 text-sm">
          <p>
            <strong className="text-error">{intl.NOTE}</strong>
            <strong>{intl.ACTIVE_DISCOUNTS}</strong>
            {intl.MAY_BE_LOST_IF_YOU_CANCEL_SUBSCRIPTION}
          </p>
        </div>
      </Card>
    </section>
  );
};
